import { useRef, useState } from "react";

import { Autocomplete, CircularProgress, TextField } from "@mui/material";

import { Grupo } from "../../types/grupo/Grupo";
import useGrupoFetch from "./useGrupoFetch";


type Props = {
    isdisabled?: boolean;
    isLoading?: boolean;
    required?: boolean;
    value?: Grupo | null;
    handleSearchChange: (newValue: Grupo) => void;
};


const TxtGrupo = ({
    isdisabled,
    isLoading,

    required,
    value,
    handleSearchChange,

}: Props) => {


    const timeoutRef = useRef<number | null>(null);
    const loading = useRef(false);




    const handleSetLoad = (newValue: boolean) => {
        loading.current = newValue;
    };

    const [inputValue, setInputValue] = useState("");
    const { options } = useGrupoFetch({ inputValue, handleSetLoad });


    return (
        <Autocomplete

            value={value && value.id ? value : null} // 
            size="small"
            options={options}
            isOptionEqualToValue={(option, value) => option.id === value.id}

            getOptionLabel={(option) => {
                const grupo = option as Grupo;
                return grupo.nome ? grupo.nome : "";
            }}
            loading={loading.current}

            onInputChange={(event, newInputValue) => {

                if (timeoutRef.current) {
                    clearTimeout(timeoutRef.current);
                }
                timeoutRef.current = window.setTimeout(() => {
                    setInputValue(newInputValue);


                }, 700); // 300ms delay
            }}

            onChange={(event, newValue) => {
                handleSearchChange(newValue as Grupo);
            }}


            renderInput={(params) => (
                <TextField
                    {...params}
                    label="Grupo de Acompanhamento"
                    required={required ? true : false}
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <>
                                {loading.current ? (
                                    <CircularProgress color="inherit" size={20} />
                                ) : null}
                                {params.InputProps.endAdornment}
                            </>
                        ),
                    }}
                />
            )}

        />
    );








}
export default TxtGrupo;

